// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import translate01Icon from "@/assets/icons/translate-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Translate01IconProps = Omit<IconProps, "name">;

export function Translate01Icon(props: Translate01IconProps): React.ReactNode {
  return <Icon name={translate01Icon} {...props} />;
}
